export interface Category {
  id: string;
  nameKey: string;
  url: string;
  image: string;
  seq: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    nameKey: 'category_shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20sneakers%20collection%20on%20clean%20white%20background%20product%20photography%20flat%20lay%20minimalist%20style%20high%20end%20streetwear%20shoes%20aesthetic&width=400&height=400&seq=cat-shoes-01&orientation=squarish',
    seq: 'cat-shoes-01',
  },
  {
    id: 'hoodies',
    nameKey: 'category_hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Premium%20hoodie%20sweater%20fashion%20flat%20lay%20on%20neutral%20beige%20background%20minimalist%20product%20photography%20warm%20tones%20soft%20lighting%20streetwear%20aesthetic&width=400&height=400&seq=cat-hoodies-01&orientation=squarish',
    seq: 'cat-hoodies-01',
  },
  {
    id: 'tshirts',
    nameKey: 'category_tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20t-shirts%20collection%20flat%20lay%20fashion%20photography%20clean%20white%20background%20casual%20streetwear%20aesthetic%20soft%20natural%20lighting&width=400&height=400&seq=cat-tshirts-01&orientation=squarish',
    seq: 'cat-tshirts-01',
  },
  {
    id: 'jackets',
    nameKey: 'category_jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20jacket%20outerwear%20fashion%20product%20photography%20hanging%20on%20wooden%20hanger%20minimalist%20background%20warm%20neutral%20tones%20editorial%20style&width=400&height=400&seq=cat-jackets-01&orientation=squarish',
    seq: 'cat-jackets-01',
  },
  {
    id: 'pants',
    nameKey: 'category_pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Casual%20pants%20shorts%20fashion%20flat%20lay%20minimalist%20product%20photography%20clean%20beige%20background%20soft%20lighting%20streetwear%20style&width=400&height=400&seq=cat-pants-01&orientation=squarish',
    seq: 'cat-pants-01',
  },
  {
    id: 'headwear',
    nameKey: 'category_headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20caps%20hats%20headwear%20collection%20flat%20lay%20minimalist%20product%20photography%20clean%20background%20soft%20natural%20lighting%20streetwear%20aesthetic&width=400&height=400&seq=cat-headwear-01&orientation=squarish',
    seq: 'cat-headwear-01',
  },
  {
    id: 'sets',
    nameKey: 'category_sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20outfit%20set%20fashion%20flat%20lay%20product%20photography%20minimalist%20neutral%20background%20soft%20warm%20lighting%20editorial%20style&width=400&height=400&seq=cat-sets-01&orientation=squarish',
    seq: 'cat-sets-01',
  },
  {
    id: 'underwear',
    nameKey: 'category_underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20underwear%20basics%20product%20photography%20clean%20neutral%20background%20soft%20lighting%20simple%20elegant%20composition%20fashion%20essentials&width=400&height=400&seq=cat-underwear-01&orientation=squarish',
    seq: 'cat-underwear-01',
  },
  {
    id: 'jersey',
    nameKey: 'category_jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Sports%20jersey%20football%20basketball%20shirt%20product%20photography%20flat%20lay%20minimalist%20background%20clean%20composition%20soft%20lighting%20streetwear%20aesthetic&width=400&height=400&seq=cat-jersey-01&orientation=squarish',
    seq: 'cat-jersey-01',
  },
  {
    id: 'accessories',
    nameKey: 'category_accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20accessories%20collection%20jewelry%20sunglasses%20watches%20flat%20lay%20minimalist%20product%20photography%20clean%20background%20soft%20lighting%20editorial%20style&width=400&height=400&seq=cat-accessories-01&orientation=squarish',
    seq: 'cat-accessories-01',
  },
  {
    id: 'bags',
    nameKey: 'category_bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20bags%20backpacks%20collection%20product%20photography%20minimalist%20clean%20background%20soft%20natural%20lighting%20editorial%20style%20luxury%20streetwear%20aesthetic&width=400&height=400&seq=cat-bags-01&orientation=squarish',
    seq: 'cat-bags-01',
  },
  {
    id: 'belts',
    nameKey: 'category_belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Fashion%20belts%20collection%20leather%20accessories%20product%20photography%20flat%20lay%20minimalist%20neutral%20background%20soft%20warm%20lighting%20clean%20composition&width=400&height=400&seq=cat-belts-01&orientation=squarish',
    seq: 'cat-belts-01',
  },
  {
    id: 'perfumes',
    nameKey: 'category_perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottles%20collection%20product%20photography%20minimalist%20clean%20background%20soft%20elegant%20lighting%20editorial%20style%20beauty%20aesthetic&width=400&height=400&seq=cat-perfumes-01&orientation=squarish',
    seq: 'cat-perfumes-01',
  },
  {
    id: 'other',
    nameKey: 'category_other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Mixed%20fashion%20lifestyle%20products%20collection%20flat%20lay%20minimalist%20product%20photography%20clean%20neutral%20background%20soft%20lighting%20editorial%20style%20eclectic&width=400&height=400&seq=cat-other-01&orientation=squarish',
    seq: 'cat-other-01',
  },
];